import Vue,{Transition} from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Scrollactive from 'vue-scrollactive';
import VueRouter from 'vue-router'
import routes from './router';
import VueMeta from 'vue-meta';


// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// For Vue typed JS animation
import VueTyperPlugin from 'vue-typer'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faWhatsapp,faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'


Vue.use(VueRouter);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMeta);

Vue.use(VueTyperPlugin)
Vue.component('transition',Transition);
Vue.component('scrollactiveComp', Scrollactive);

library.add(faWhatsapp)
library.add(faEnvelope)
library.add(faInstagram)
library.add(faFacebook)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const router=new VueRouter({
  mode: 'history',

  routes:routes
});

router.afterEach((to) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: to.fullPath,
    page_title: document.title,
    page_location: window.location.href
  });
});

Vue.config.productionTip = false




new Vue({
  render: h => h(App),
  router
}).$mount('#app')
